import React from "react";
import { Popup } from "components/popups/Popup";
import Button from "components/shared/button";
import useTranslation from "utils/hooks/useTranslation";
import { type PopupProps } from "./Popup";
import { SvgWarning } from "components/svg";

export interface ConfirmationPopupProps extends PopupProps {
  title?: string;
  message?: string;
  translateMessage?: boolean;
  icon?: string;
  positiveCallback: () => void;
  positiveButtonText?: string;
  negativeCallBack?: () => void;
  negativeButtonText?: string;
}

export const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  title = "",
  message = "",
  translateMessage = false,
  icon = "",
  positiveCallback,
  positiveButtonText: outerPositiveButtonText,
  negativeCallBack,
  negativeButtonText: outerNegativeButtonText,
  //...rest
}) => {
  const { t, tHtml } = useTranslation();
  const positiveButtonText = outerPositiveButtonText || t("YES");
  const negativeButtonText = outerNegativeButtonText || t("NO");

  return (
    <Popup
      //noHeader 
      noHorizontalLine={true}
      fixSize="middle"
    //{...rest}
    >
      {({ onClose }) => {
        return (
          <group>
            {icon &&
              <group
                data-space="5"
                data-direction="column"
              >
                {icon === "warning" && <icon data-svg-size="48" data-svg-color="main" data-shrink="no"><SvgWarning /></icon>}
              </group>
            }
            <group
              data-direction="column"
              data-gap="20"
              data-space="40"
              data-space-horizontal="40"
              data-space-top="5"
              data-height="autofit"
            >
              <group data-gap="10" data-space-vertical="20">
                <group data-direction="column" data-gap="10" data-length="autofit"  >
                  <text data-weight="600" data-text-size="larger" data-text-align="center" 
                    //data-ellipsis="" 
                    data-wrap="wrap"
                    data-color="main"
                    >
                    {title}
                  </text>

                  <text
                    data-text-align="center" 
                    data-wrap="wrap"
                    data-text-size="13"
                    data-wrap-line="">
                    {translateMessage ? tHtml(message) : message}
                  </text>
                </group>
              </group>
            </group>
            
            <group
              data-space="30"
              data-gap="10"
              //data-background="highlight"
              //data-type="grid"
            >

              <group data-direction="row" data-position="bottom">
                <group data-justify="center" data-gap="20"  data-length="autofit" data-fit="1">
                  <Button
                    accent
                    secondary
                    large
                    onClick={() => {
                      negativeCallBack?.();
                      onClose?.();
                    }}
                  >
                    {negativeButtonText}
                  </Button>
                  <Button
                    secondary
                    large
                    onClick={() => {
                      positiveCallback?.();
                      onClose?.();
                    }}
                  // onClick={handleSubmit(onSubmit)}
                  >
                    {positiveButtonText}
                  </Button>
                </group>
              </group>
            </group>


          </group>
        );
      }}
    </Popup>
  );
};
